import { gql } from '@apollo/client'

export const GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS = gql`
  query GetAllStatusTransitionsByCurrentStatusId($current_status_id: Int!) {
    getAllStatusTransitionsByCurrentStatusId(
      current_status_id: $current_status_id
    ) {
      id
      current_status_id
      next_status_id
      NextStatusData {
        id
        name
        type
        description
        progress
        color
        order
      }
    }
  }
`

export const CREATE_STATUS_TRANSITION = gql`
  mutation CreateStatusTransition(
    $current_status_id: Int!
    $next_status_id: Int!
  ) {
    createStatusTransition(
      current_status_id: $current_status_id
      next_status_id: $next_status_id
    ) {
      id
    }
  }
`

export const DELETE_STATUS_TRANSITION = gql`
  mutation DeleteStatusTransition($id: Int!) {
    deleteStatusTransition(id: $id)
  }
`

export const GET_ALL_STATUS_AVAILABLE_TO_TRANSITIONS = gql`
  query GetAllStatusAvailabesNotInTransitions($current_status_id: Int!) {
    getAllStatusAvailabesNotInTransitions(
      current_status_id: $current_status_id
    ) {
      id
      name
      type
      description
      progress
      color
      order
    }
  }
`
